module.exports = __webpack_public_path__ + "static/media/style.199826ea.scss";


//////////////////
// WEBPACK FOOTER
// ./src/views/avicollectDashboard/style.scss
// module id = 715
// module chunks = 0